// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Cl0E","col":"styles_col__18HJV"};